// Non-secret admin identification settings (adjust as needed)
export const ADMIN_ROLE = 'AppAdmin';
export const ADMIN_GROUP_ID = '00000000-0000-0000-0000-000000000000';
export const ADMIN_CUSTOM_CLAIM = 'extension_isAdmin';
